const stringToColor = (string) => {
  let hash = 0;
  let i;
  for (i = 0; i < string?.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }
  let color = '#';
  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }
  return color;
};

const genReqId = () => {
  return 'req_' + Math.random().toString(36).slice(2);
}

export const getReactEnvSafe = () => {
  if (typeof process !== "undefined" && process.env) {
    return process.env;
  }

  return {};
};

const getParentOriginStrict = () => {
  const reactEnv = getReactEnvSafe();
  const procEnv = (typeof process !== 'undefined' && process && process.env) ? process.env : {};
  const env = reactEnv || procEnv || {};

  const WRAPPER_ORIGIN = env.REACT_APP_WRAPPER_ORIGIN || null;
  if (WRAPPER_ORIGIN) return WRAPPER_ORIGIN;

  if (typeof document !== 'undefined' && document.referrer) {
    try {
      const o = new URL(document.referrer).origin;
      if (o && o !== 'null') return o;
    } catch (_) {
      // ignore invalid referrer
    }
  }

  const MODE = (env.MODE || env.NODE_ENV || '').toLowerCase();
  if (MODE === 'development') return '*';

  throw new Error("Impossible de déterminer l'origin du parent; configure REACT_WRAPPER_ORIGIN (ou REACT_APP_WRAPPER_ORIGIN).");
}

const utils = {
  // function to format id
  format: (num) => {
    return String(num).padStart(5, "0");
  },

  // function to format price
  round: (number) => {
    const value = Number(number);
    return Math.sign(value) * Math.round((Math.abs(value) + Number.EPSILON) * 100) / 100;
  },

  // token header
  tokenHeader: (token) => {
    return {
      headers: {
        "X-Requested-With": "XMLHttpRequest",
        Authorization: `Bearer ${token}`,
      },
    };
  },

  header: () => {
    return {
      headers: {
        "X-Requested-With": "XMLHttpRequest",
        "Content-Type": "application/json",
      },
    };
  },

  parameters: [
    {
      include: [
        {
          relation: "hasCurrency"
        }
      ]
    },
    {
      include: [
        {
          relation: "hasCategories",
          scope: {
            include: [
              {
                relation: "hasItems",
                scope: {
                  include: [
                    {
                      relation: "hasOptions"
                    }
                  ]
                }
              }
            ]
          }
        }
      ]
    },
    {
      include: [
        {
          relation: "hasInvoices",
        }
      ]
    },
    {
      include: [
        {
          relation: "hasDesignation",
        }
      ]
    },
    {
      include: [
        {
          relation: "hasEvents",
        }
      ]
    },
    {
      include: [
        {
          relation: "hasExpenses",
          scope: {
            include: [
              {
                relation: "hasExpenseType",
              }
            ]
          }
        }
      ]
    },
    {
      include: [
        {
          relation: "hasExpenseType",
        }
      ]
    }
  ],

  stringAvatar: (name) => {
    return {
      sx: {
        bgcolor: stringToColor(name),
      },
      children: `${name?.split(' ')[0][0]}`.toUpperCase(),
    };
  },

  stringToColor: (str) => {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    const hue = hash % 360;
    return `hsl(${hue}, 70%, 50%)`; // bright enough for text
  },

  /*getKey: (obj, valueToFind) => (
    Object.entries(obj).find(([_, value]) => value.toLowerCase() === valueToFind.toLowerCase())?.[0]
  ),*/

  addFieldAtPosition: (obj, key, value, position) => {
    const entries = Object.entries(obj);
    entries.splice(position, 0, [key, value]);
    return Object.fromEntries(entries);
  },

  isEmpty: (value) => {
    return (
      value === null || value === undefined ||
      (typeof value === 'string' && value.trim() === '') ||
      (Array.isArray(value) && value.length === 0) ||
      (typeof value === 'object' && Object.keys(value).length === 0)
    );
  },

  calculateTotalAmount: (invoices) => {
    return invoices.reduce(
      (sum, invoice) => sum + (Number(invoice.totalAmount) || 0),
      0
    );
  },

  /**
   * Envoie un job d'impression au wrapper (si dans un iframe),
   * sinon fallback vers l'API backend.
   */
  printReceipt: (job) => {
    const targetOrigin = getParentOriginStrict();
    const reqId = genReqId();

    return new Promise(function (resolve, reject) {
      const timer = window.setTimeout(function () {
        window.removeEventListener('message', onMessage);
        reject(new Error('Timeout print (15s)'));
      }, 15000);

      function onMessage(ev) {
        if (targetOrigin !== '*' && ev.origin !== targetOrigin) return;
        if (ev.source !== window.parent) return;
        const data = ev.data || {};
        if (data.type !== 'POS_PRINT_DONE' || data.reqId !== reqId) return;

        window.clearTimeout(timer);
        window.removeEventListener('message', onMessage);
        if (data.ok) resolve(data);
        else reject(new Error(data.error || 'Print failed'));
      }

      window.addEventListener('message', onMessage);

      //job.printerMac = localStorage.getItem('printerMac');

      const payload = { type: 'POS_PRINT', reqId: reqId, job: job };
      try {
        window.parent.postMessage(payload, targetOrigin);
      } catch (e) {
        window.removeEventListener('message', onMessage);
        window.clearTimeout(timer);
        reject(e instanceof Error ? e : new Error(String(e)));
      }
    });
  },

  capitalizeFirst: (text) => {
    if (!text) return "";
    return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
  },

  shortHashToNumber: (str) => {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      hash = (hash * 31 + str.charCodeAt(i)) % 1000000; // Keep it within 6 digits
    }
    return hash;
  },

  formatItemName: (name) => {
  const match = name.match(/^\[(.+?)\]\s*(.+)$/);
  return match ? `${match[2]} [${match[1]}]` : name;
},

  // "Frais de déplacement" is a manually-added administrative fee (see
  // handleDeplacement in pos2.jsx), not a real prestation/product — it has no
  // categoryName, so it can only be recognized by its stored itemName. Invoices
  // may hold either translation depending on the cashier's UI language at the
  // time of sale, so both must be matched regardless of the current locale.
  isDeplacementFeeItem: (itemName) => {
    const normalized = String(itemName || "").trim().toLowerCase();
    return normalized === "frais de déplacement" || normalized === "deplacement fee";
  },
};

export default utils;
